import { render, staticRenderFns } from "./SmallStats.vue?vue&type=template&id=f427642c&"
import script from "./SmallStats.vue?vue&type=script&lang=js&"
export * from "./SmallStats.vue?vue&type=script&lang=js&"
import style0 from "./SmallStats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports